<template>
  <div>
    <allUser />
  </div>
</template>

<script>
import allUser from "../../../components/adminComponent/rolemanagement/allUser";
export default {
  name: "AllUser",
  components: {
    allUser
  }
};
</script>
